import { get } from '@tovala/browser-apis-cdn'

import { APP_ID } from 'utils/api'

import {
  GetMenuProductRatingAveragesRequest,
  GetMenuProductRatingAveragesResponse,
} from '../combinedapi/menuProductRatingAverages'

export const ENDPOINTS = {
  GET_MENU_PRODUCT_RATING_AVERAGES: ({
    menuID,
  }: Pick<GetMenuProductRatingAveragesRequest, 'menuID'>) => ({
    path: `/v2/menus/${menuID}/menuProductRatingAverages`,
  }),
}

export async function getMenuProductRatingAveragesFromCDN({
  menuID,
}: GetMenuProductRatingAveragesRequest) {
  return get<GetMenuProductRatingAveragesResponse>({
    ...ENDPOINTS.GET_MENU_PRODUCT_RATING_AVERAGES({ menuID }),
    config: { headers: { 'X-Tovala-AppID': APP_ID } },
  })
}
